/* Copyright (c) 2025 MOCA Systems, Inc.  All rights reserved. */
import { Injectable } from '@angular/core';
import { filter } from 'rxjs/operators';
import { Milestone } from '@touchplan/common';
import { PlanMilestone } from '../../../common/fancy-firebase/objects/PlanMilestone';
import { AbstractCanvasConnection } from './AbstractCanvasConnection';

export interface IPlanMilestone extends Milestone {
	isSet: boolean;
}

@Injectable({ providedIn: 'root' })
export class MilestoneLineService extends AbstractCanvasConnection<IPlanMilestone> {
	// BEGIN PLACEHOLDER: Replace as part of TP-6852
	/**
	 * We get a reference to the entire planState and not only the scopeSoup because of loading order shenanigans
	 * @private
	 */
	private _planState: any;
	// END PLACEHOLDER
	/**
	 * Registers the service to receive milestone data from a `FancyFirebaseObject`
	 * @param fancyObject PlanMilestone object representing Plan Milestone data
	 * @param planState PlanState object
	 */
	// BEGIN PLACEHOLDER: Replace as part of TP-6852
	public registerPlanData(fancyObject: PlanMilestone, planState: any): void {
		// We get a reference to the entire planState and not only the scopeSoup because of loading order shenanigans
		// By the time we register plan data, the scopeSoup has not been initialized yet...
		// So...since this will be replaced with a new calendar, figured it would be easier to only suffer a little bit.
		this._planState = planState;
		// END PLACEHOLDER
		super.registerPlanData();

		this._subscription = fancyObject.object$
			.pipe(filter((data: Milestone) => !!data))
			.subscribe((data: Milestone) => {
				this._changed$.next({
					daysBehind: data.daysBehind,
					scheduleDate: data.scheduleDate,
					scheduleX: data.scheduleX,
					targetX: data.targetX,
					targetDate: data.targetDate,
					activityName: data.activityName,
					isSet: !!data.targetDate,
				});
			});
	}
	public showCalendar(): void {
		// BEGIN PLACEHOLDER: Replace as part of TP-6852
		this._planState.scopeSoup.showFloatingMilestoneCal();
		// END PLACEHOLDER
	}
}
